import Svg, { Path } from 'react-native-svg'
/* SVGR has dropped some elements not supported by react-native-svg: filter */
const Swap = ({ width = 16, height = 16, color = '#fff' }: any) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
    <Path
      fill={color}
      d="M8.667 5.333H3.333a2 2 0 0 0-2 2v5.333a2 2 0 0 0 2 2h5.334a2 2 0 0 0 2-2V7.333a2 2 0 0 0-2-2Zm4-4H7.333a2 2 0 0 0-2 2V4h3.334A3.333 3.333 0 0 1 12 7.333v3.333h.667a2 2 0 0 0 2-2V3.333a2 2 0 0 0-2-2Z"
      opacity={0.7}
    />
  </Svg>
)
export default Swap
